export default __webpack_public_path__ + "static/media/sounds/vocab_bd_practice_instruction_start.mp3";